import { render, staticRenderFns } from "./TabBasicInfo.vue?vue&type=template&id=66d1c036&scoped=true&"
import script from "./TabBasicInfo.vue?vue&type=script&lang=js&"
export * from "./TabBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./TabBasicInfo.vue?vue&type=style&index=0&id=66d1c036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d1c036",
  null
  
)

export default component.exports